<p-table [value]="data"  [lazy]="true" [paginator]="true"
[totalRecords]="totalRecord" [rows]="pageSize" [showCurrentPageReport]="true"
[first]="first" styleClass="p-datatable-gridlines floatthead"
currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
 (onPage)="getData($event)">
    <ng-template pTemplate="header">
        <tr>
            <th id="fileName">File Name</th>
            <th id="type">Serial Type</th>
            <th id="date">Imported Date</th>
            <th id="importedBy">Imported By</th>
            <th id="action">Actions</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-imp let-i="rowIndex">
        <tr>
            <td>{{imp.fileName}}</td>
            <td>{{imp.serialTypeName}}</td>
            <td>{{imp.createdDate | date: 'MM/dd/yyyy'}}</td>
            <td>{{imp.createdByName}}</td>
            <td class="action">
                <span class="btnBars p-mr-0" pTooltip="Rollback" tooltipPosition="top" (click)="rollBackImport(imp)">
                    <i class="pi pi-undo"></i>
                </span>
            </td>
        </tr>
    </ng-template>
</p-table>